module.exports = __webpack_public_path__ + "static/img/u2.4317615.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u2.png
// module id = oFnj
// module chunks = 1